exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".multiselect[data-v-dd980ca8]{background-color:#fff}", ""]);

// exports
